// Loud "flash alert" audio + vibration for admin broadcasts.
// Uses Web Audio API so no static asset is required. Designed to be
// noticeably more prominent than the standard notification chime
// (three quick alarm sweeps ~1.3 s total).

let _ctx = null;
function _getCtx() {
  const Ctx = typeof window !== "undefined" && (window.AudioContext || window.webkitAudioContext);
  if (!Ctx) return null;
  if (!_ctx) _ctx = new Ctx();
  if (_ctx.state === "suspended") _ctx.resume().catch(() => {});
  return _ctx;
}

/**
 * Plays a prominent 3-burst alarm tone (~1.3 s total) using the Web Audio API.
 * Skips if `silent` is true.
 */
export function playFlashAlarm({ silent = false, volume = 0.9 } = {}) {
  if (silent) return;
  try {
    const ctx = _getCtx();
    if (!ctx) return;
    const now = ctx.currentTime;

    const burst = (start) => {
      // Ascending square-wave sweep 700 → 1500 Hz for maximum attention.
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = "square";
      osc.frequency.setValueAtTime(700, now + start);
      osc.frequency.linearRampToValueAtTime(1500, now + start + 0.18);
      osc.frequency.linearRampToValueAtTime(900, now + start + 0.32);
      g.gain.setValueAtTime(0, now + start);
      g.gain.linearRampToValueAtTime(0.5 * volume, now + start + 0.02);
      g.gain.linearRampToValueAtTime(0.5 * volume, now + start + 0.28);
      g.gain.exponentialRampToValueAtTime(0.0001, now + start + 0.36);
      osc.connect(g);
      g.connect(ctx.destination);
      osc.start(now + start);
      osc.stop(now + start + 0.4);
    };

    burst(0);
    burst(0.42);
    burst(0.84);
  } catch { /* noop */ }
}

/**
 * Triggers a 3-pulse vibration pattern on supported devices.
 * Skips if `silent` is true.
 */
export function vibrateFlash({ silent = false } = {}) {
  if (silent) return;
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      // Pattern: vibrate 250ms, pause 120ms, vibrate 250ms, pause 120ms, vibrate 400ms
      navigator.vibrate([250, 120, 250, 120, 400]);
    }
  } catch { /* noop */ }
}
